import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext } from 'react';
import { hasPublisherHaveBackgroundImage } from '@/utils/publisher';
import { cn } from '@/utils/cn';

export const ProfileCircle = () => {
  const { boot, template } = useContext(CheckoutContext);
  const hasBackgroundImage = hasPublisherHaveBackgroundImage(boot?.checkoutTheme, template.type);
  return (
    <div
      className={cn(
        'flex items-center justify-center align-middle w-10 h-10 rounded-full bg-muted-light',
        hasBackgroundImage ? 'bg-transparent' : ''
      )}
    >
      <img
        src={boot.checkoutTheme?.logo ?? boot.theme?.logo}
        alt="player avatar"
        className="object-cover rounded-full"
      />
    </div>
  );
};
